import React, { useContext, useState } from "react";
import { func, bool, string } from "prop-types";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { AddStorageDataContext } from "context/AddStorageContext";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { RESOLUTIONS } from "services/config";
import * as StorageUtils from "utils/StorageUtils";
import { StorageApi } from "services/storage";
import { Utils } from "services/utils";
import { BloxButton } from "styled_components/Common/BloxButton";
import { AddShareHeader } from "styled_components/Storage/AddShareHeader";
import { ConfirmationScreen } from "styled_components/Common/ConfirmationScreen";
import { useActiveScreen } from "hooks/useActiveScreen";
import { ShareLocationScreen } from "./Screens/ShareLocationScreen";
import { RedundancyScreen } from "./Screens/RedundancyScreen";
import { ShareIconScreen } from "./Screens/ShareIconScreen";
import { ShareAccessScreen } from "./Screens/ShareAccessScreen";
import { ShareWhitelistScreen } from "./Screens/ShareWhitelistScreen";
import { ShareNameScreen } from "./Screens/ShareNameScreen";
import { ShareReviewScreen } from "./Screens/ShareReviewScreen";

const SCREENS = {
  0: ShareIconScreen,
  1: ShareNameScreen,
  2: ShareLocationScreen,
  3: RedundancyScreen,
  4: ShareLocationScreen,
  5: ShareAccessScreen,
  6: ShareWhitelistScreen,
  7: ShareReviewScreen,
  8: ConfirmationScreen,
};

const TITLE = {
  0: "Now, let's personalize your Share with a unique color and icon.",
  1: "Now. Let's name your Share.",
  2: "What is your primary location?",
  3: "Do you want redundancy for your storage?",
  4: "Great. Now, choose your secondary location.",
  5: "Now, choose Private or Public Access.",
  6: "Now, let's set your Whitelist IP addresses.",
  7: "REVIEW",
  8: "Confirmed",
};

function getSize(breakpoint) {
  let size = "medium";
  if (breakpoint === RESOLUTIONS.MED) {
    size = "medium";
  } else if (breakpoint === RESOLUTIONS.HIGH) {
    size = "medium";
  }

  return size;
}
function getHeader(index, inputs) {
  return <AddShareHeader title={TITLE[index]} inputs={inputs} index={index} />;
}
function checkValidation(activePage, inputs) {
  let valid = false;

  switch (activePage) {
    case 0:
      const icon = inputs?.icon;
      const color = inputs?.color;

      if (icon !== "" && color !== "#ffffff") {
        valid = true;
      }
      break;
    case 1:
      const name = inputs?.name;
      if (name !== "" && name.length > 3) {
        valid = true;
      }

      break;
    case 2:
      const location = inputs?.primaryLocation;
      if (location !== "") {
        valid = true;
      }

      break;
    case 3:
      const redundancy = inputs?.redundancy;
      if (redundancy !== "") {
        valid = true;
      }

      break;
    case 4:
      const secondarylocation = inputs?.secondaryLocation;
      if (secondarylocation !== "") {
        valid = true;
      }
      break;
    case 5:
      const access = inputs?.access;
      if (access !== "") {
        valid = true;
      }
      break;
    case 6:
      valid = checkIP(inputs);
      break;
    case 7:
      valid = checkSubmitted(inputs);
      break;
    default:
  }
  return valid;
}

function checkIP(inputs) {
  let valid = false;
  const whitelist = inputs?.whitelist;
  const ips = whitelist?.ips;

  if (
    ips &&
    ips.length !== 0 &&
    ips.every((ip) => StorageUtils.validateIpAddress(ip.ip))
  ) {
    valid = true;
  }
  return valid;
}

function checkSubmitted(inputs) {
  let valid;
  if (inputs.submitted) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
}
function getButtonText(inputs, activePage) {
  let text = "NEXT";

  switch (activePage) {
    case 0:
      if (inputs.review) {
        text = "REVIEW";
      }
      break;
    case 1:
      if (inputs.review) {
        text = "REVIEW";
      }
      break;
    case 2:
      if (inputs.review) {
        text = "REVIEW";
      }
      break;
    case 3:
      if (inputs.review) {
        text = "REVIEW";
      }
      break;
    case 4:
      if (inputs.review) {
        text = "REVIEW";
      }
      break;
    case 5:
      if (inputs.review) {
        text = "REVIEW";
      }
      break;
    case 6:
      if (inputs.review) {
        text = "REVIEW";
      }
      break;
    case 7:
      text = "SUBMIT";
      break;
    default:
  }
  return text;
}
function getButtonFunction(
  buttonText,
  activePage,
  setActivePageIndex,
  setModalContent,
  inputs,
  setCaseId,
  change,
  orgId,
  userId,
  getShares,
  ticketType,
  auth_status
) {
  const redundancy = inputs?.redundancy;

  if (
    activePage === 0 ||
    activePage === 1 ||
    activePage === 2 ||
    activePage === 3 ||
    activePage === 4 ||
    activePage === 5 ||
    activePage === 6
  ) {
    if (buttonText === "REVIEW") {
      return () => setActivePageIndex(7);
    } else if (activePage === 3 && !redundancy) {
      return () => setActivePageIndex(activePage + 2);
    } else {
      return () => setActivePageIndex(activePage + 1);
    }
  } else if (activePage === 7) {
    return () => {
      change({ target: { name: "submitted", value: true } });
      submit(
        setActivePageIndex,
        setModalContent,
        inputs,
        setCaseId,
        change,
        orgId,
        userId,
        getShares,
        ticketType,
        auth_status
      );
    };
  }
}

async function submit(
  setActivePageIndex,
  setModalContent,
  inputs,
  setCaseId,
  change,
  orgId,
  userId,
  getShares,
  ticketType
) {
  const params = StorageUtils.formatStorageAddParams(inputs, userId);
  const button = (
    <BloxButton
      className="buttons41"
      id="okay"
      text="OKAY"
      module="storage"
      enabled={true}
      onClick={() => {}}
      cypressId="okay"
    />
  );

  const response = await StorageApi.addStorage(params, orgId);

  if (Utils.isValidResponse(response) && response.data.successful) {
    if (ticketType?.bonita) {
      setActivePageIndex(8);
      setCaseId(response.data?.caseId);
      getShares();
    }
  } else if (response.data.hasNamingError) {
    change({ target: { name: "submitted", value: false } });
    const namingError = `${inputs?.name} has already been used. Please choose a different name and try again.`;
    setModalContent("TIMEOUT_CLOSE", namingError, button);
  } else {
    change({ target: { name: "submitted", value: false } });
    setModalContent("TIMEOUT_CLOSE", "Network error adding storage", button);
  }
}

function getButtonFunction2(activePage, setActivePageIndex, inputs) {
  if (activePage === 5 && !inputs?.redundancy) {
    return () => setActivePageIndex(activePage - 2);
  } else if (setActivePageIndex && activePage !== 0 && activePage !== 7) {
    return () => setActivePageIndex(activePage - 1);
  } else {
    return null;
  }
}

export const AddStorageModal = ({
  closeModal,
  breakpoint,
  showModal,
  setModalContent,
  navigate,
  orgId,
  userId,
  getShares,
  ticketType,
  auth_status,
}) => {
  const { activePageIndex, setActivePageIndex } = useActiveScreen(0);
  const [caseId, setCaseId] = useState(null);
  const { inputs, change } = useContext(AddStorageDataContext);
  const Screen = SCREENS[activePageIndex];

  const buttonText = getButtonText(inputs, activePageIndex);
  function resetModal() {
    change({ target: { name: "primaryLocation", value: "" } });
    change({ target: { name: "secondaryLocation", value: "" } });
    change({ target: { name: "redundancy", value: "" } });
    change({ target: { name: "access", value: "" } });
    change({ target: { name: "name", value: "" } });
    change({ target: { name: "icon", value: "" } });
    change({ target: { name: "whitelist", value: [] } });
    change({ target: { name: "review", value: false } });
    change({ target: { name: "submitted", value: false } });
    change({ target: { name: "color", value: "#ffffff" } });

    closeModal();
    setActivePageIndex(0);
  }

  return (
    <PortraitModalComponent
      closeModal={resetModal}
      show={showModal}
      header={getHeader(activePageIndex, inputs)}
      title="STORAGE ADD REQUEST"
      subTitle={""}
      size={getSize(breakpoint)}
      breakpoint={breakpoint}
    >
      <Screen
        activePageIndex={activePageIndex}
        setActivePageIndex={setActivePageIndex}
        caseId={caseId}
        resetModal={resetModal}
        navigate={navigate}
      />
      <ModalFooter
        cypressId="footer"
        id="footer"
        buttonText1={buttonText}
        buttonText2="Back"
        buttonActive1={checkValidation(activePageIndex, inputs)}
        buttonActive2={!inputs?.submitted}
        module="storage"
        buttonFunction1={getButtonFunction(
          buttonText,
          activePageIndex,
          setActivePageIndex,
          setModalContent,
          inputs,
          setCaseId,
          change,
          orgId,
          userId,
          getShares,
          ticketType,
          auth_status
        )}
        size={getSize(breakpoint)}
        buttonFunction2={getButtonFunction2(
          activePageIndex,
          setActivePageIndex,
          inputs
        )}
      />
    </PortraitModalComponent>
  );
};

AddStorageModal.propTypes = {
  closeModal: func.isRequired,
  breakpoint: string.isRequired,
  showModal: bool.isRequired,
  id: string,
  setModalContent: func.isRequired,
};

AddStorageModal.defaultProps = {};
